export default {
  'vip.exchange.title': 'VIP成长值兑换配置',
  'vip.exchange.ruleTitle': 'VIP规则说明',
  'vip.exchange.currency': '币种',
  'vip.exchange.amount': '金额',
  'vip.exchange.growthValue': 'VIP成长值',
  'vip.exchange.enterAmount': '请输入金额',
  'vip.exchange.enterGrowthValue': '请输入成长值',
  'vip.exchange.enterValidNumber': '请输入有效数字（最多两位小数）',
  'vip.exchange.enterPositiveInteger': '请输入正整数',
  'vip.exchange.refresh': '刷新',
  'vip.exchange.save': '保存',
  'vip.exchange.saveSuccess': '保存成功',
  'vip.exchange.saveFailed': '保存失败，请检查输入',
  'vip.exchange.dataLoadFailed': '数据加载失败',
  'vip.exchange.ruleContent': '请输入VIP规则说明',
  'vip.exchange.ruleContentRequired': '请输入VIP规则说明',
  'vip.log.grow.title': 'VIP成长值记录',
  'vip.log.level.title': 'VIP变更纪录',
  'vip.log.memberAccount': '会员账号',
  'vip.log.level': 'VIP等级',
  'vip.log.changeReason': '变动原因',
  'vip.log.beforeGrow': '变动前VIP成长值',
  'vip.log.grow': 'VIP成长值变动',
  'vip.log.afterGrow': '变动后VIP成长值',
  'vip.log.createTime': '创建时间',
  'vip.log.changeTime': '变更时间',
  'vip.log.changeType': '变更类型',
  'vip.log.beforeLevel': '变更前',
  'vip.log.afterLevel': '变更后',
  'vip.log.operator': '操作人',
  'vip.log.upgrade': '升级',
  'vip.log.downgrade': '降级',
  'vip.log.enterMemberAccount': '请输入用户帐号',
  'vip.log.selectChangeType': '请选择变更类型',
  'vip.setup.condition.title': 'VIP条件配置',
  'vip.setup.unifiedReward.title': 'VIP统一奖励配置',
  'vip.setup.reward.title': 'VIP礼金配置',
  'vip.setup.point.title': 'VIP积分配置',
  'vip.setup.withdrawLimit.title': 'VIP提款额度设置',
  'vip.setup.upgradeReward': '升级礼金',
  'vip.setup.flowMultiple': '流水倍数',
  'vip.setup.retentionReward': '保级礼金',
  'vip.setup.weeklySalary': '周俸禄',
  'vip.setup.weeklyRequiresDeposit': '发放需存款',
  'vip.setup.weeklyRequiresBetflow': '发放需流水',
  'vip.setup.monthlySalary': '月俸禄',
  'vip.setup.monthlyRequiresDeposit': '发放需存款',
  'vip.setup.monthlyRequiresBetflow': '发放需流水',
  'vip.setup.birthdayReward': '生日礼金',
  'vip.setup.claimValidityDays': '可领有效期（天）',
  'vip.setup.enterUpgradeReward': '请输入升级礼金',
  'vip.setup.enterFlowMultiple': '请输入流水倍数',
  'vip.setup.enterRetentionReward': '请输入保级礼金',
  'vip.setup.enterWeeklySalary': '请输入周俸禄',
  'vip.setup.enterWeeklyRequiresDeposit': '请输入发放需存款',
  'vip.setup.enterWeeklyRequiresBetflow': '请输入发放需流水',
  'vip.setup.enterMonthlySalary': '请输入月俸禄',
  'vip.setup.enterMonthlyRequiresDeposit': '请输入发放需存款',
  'vip.setup.enterMonthlyRequiresBetflow': '请输入发放需流水',
  'vip.setup.enterBirthdayReward': '请输入生日礼金',
  'vip.setup.enterClaimValidityDays': '请输入可领有效期（天）',
  'vip.setup.upgradePoint': '升级积分',
  'vip.setup.retentionPoint': '保级积分',
  'vip.setup.appDayPoint': 'APP端每日积分',
  'vip.setup.h5DayPoint': 'H5端每日积分',
  'vip.setup.verifyMobile': '手机认证',
  'vip.setup.enterUpgradePoint': '请输入升级积分',
  'vip.setup.enterRetentionPoint': '请输入保级积分',
  'vip.setup.enterAppDayPoint': '请输入APP端每日积分',
  'vip.setup.enterH5DayPoint': '请输入H5端每日积分',
  'vip.setup.upgradeGrow': '升级成长值≥',
  'vip.setup.retentionGrow': '保级成长值≥',
  'vip.setup.retentionDays': '保级有效期（天）',
  'vip.setup.unlimited': '永久有效',
  'vip.setup.enterUpgradeGrow': '请输入升级成长值',
  'vip.setup.enterRetentionGrow': '请输入保级成长值',
  'vip.setup.enterRetentionDays': '请输入保级有效期（天）',
  'vip.exchange.pageSubtitle': '按币种配置充值金额和有效流水的成长值兑换比例，支持独立开关控制',
  'vip.exchange.depositChannel': '充值兑换通道',
  'vip.exchange.depositChannelDesc': '充值到账实时转换',
  'vip.exchange.betflowChannel': '流水兑换通道',
  'vip.exchange.betflowChannelDesc': '页面触发 + 轮询异步转换',
  'vip.exchange.enabled': '已开启',
  'vip.exchange.disabled': '已关闭',
  'vip.exchange.depositAmount': '充值金额金额',
  'vip.exchange.depositGrowthValue': 'VIP成长值',
  'vip.exchange.betflowAmount': '有效流水金额',
  'vip.exchange.betflowGrowthValue': 'VIP成长值',
  'vip.exchange.description': '含义说明',
  'vip.exchange.enterBetflowAmount': '请输入有效流水金额',
  'vip.exchange.enterBetflowGrowthValue': '请输入流水成长值',
  'vip.exchange.descDeposit': '每 {{amount}} {{currency}} 充值 = {{grow}} 成长值',
  'vip.exchange.descBetflow': '每 {{amount}} {{currency}} 有效流水 = {{grow}} 成长值',
  'vip.exchange.previewSaveData': '预保存数据',
  'vip.exchange.formValidationFailed': '表单验证失败',
  'vip.setup.level': 'VIP等级',
  'vip.setup.upgradeGrowValidation': 'VIP{currentLevel} 的升级成长值 ({currentValue}) 必须大于 VIP{prevLevel} 的升级成长值 ({prevValue})',
  'vip.setup.retentionGrowValidation': 'VIP{currentLevel} 的保级成长值 ({currentValue}) 必须大于 VIP{prevLevel} 的保级成长值 ({prevValue})',
  'vip.log.memberAccountRequired': '会员帐号不得空',
  'vip.log.dataLoadFailed': '数据加载失败',
  'vip.withdrawLimit.dailyLimit': '每日提款额度',
  'vip.withdrawLimit.enterWithdrawLimit': '请输入提款额度',
  'vip.withdrawLimit.enterValidAmount': '请输入有效金额（支持小数或-1表示无限制）',
  'vip.withdrawLimit.unlimited': '无限制',
  'vip.withdrawLimit.unlimitedHint': '-1=无限制',
  'vip.withdrawLimit.enableVipWithdraw': '开启VIP限额',
  'vip.setup.ticket.title': 'VIP参与券设置',
  'vip.setup.ticket.upgradeQuantity': '参与券数量',
  'vip.setup.ticket.enterTicketNumber': '请输入参与券数量',
  'vip.setup.ticket.enterValidTicketNumber': '请输入有效的参与券数量（支持小数或-1表示无限制）',
  'vip.setup.ticket.unlimitedHint': '-1=无限制',
  'vip.setup.ticket.upgradeTicket': 'VIP升级礼赠',
  'vip.setup.ticket.selectUpgradeTicket': '请选择升级礼赠',
  'vip.setup.pointConfig.title': '积分配置',
  'vip.setup.pointConfig.minPoint': '最小积分',
  'vip.setup.pointConfig.maxPoint': '最大积分',
  'vip.setup.pointConfig.probability': '概率',
  'vip.setup.pointConfig.add': '新增',
  'vip.setup.pointConfig.delete': '删除',
  'vip.setup.pointConfig.save': '确定',
  'vip.setup.pointConfig.cancel': '取消',
  'vip.setup.pointConfig.minPointRequired': '请输入最小积分',
  'vip.setup.pointConfig.maxPointRequired': '请输入最大积分',
  'vip.setup.pointConfig.probabilityRequired': '请输入概率',
  'vip.setup.pointConfig.minPointInvalid': '最小积分必须为正整数',
  'vip.setup.pointConfig.maxPointInvalid': '最大积分必须为正整数',
  'vip.setup.pointConfig.maxLessThanMin': '最大积分不能小于最小积分',
  'vip.setup.pointConfig.probabilityInvalid': '概率必须为0-100之间的数字',
  'vip.setup.pointConfig.totalProbabilityError': '概率总和必须等于100%，当前为{total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': '概率总和必须等于100%',
  'vip.setup.pointConfig.setting': '设置',
  'vip.setup.pointConfig.totalProbability': '总概率',
  'vip.setup.pointConfig.action': '操作',
  'vip.setup.pointConfig.count': '配置项',
  'vip.setup.pointConfig.title': '积分配置',
  'vip.setup.pointConfig.minPoint': '最小积分',
  'vip.setup.pointConfig.maxPoint': '最大积分',
  'vip.setup.pointConfig.probability': '概率',
  'vip.setup.pointConfig.add': '新增',
  'vip.setup.pointConfig.delete': '删除',
  'vip.setup.pointConfig.save': '确定',
  'vip.setup.pointConfig.cancel': '取消',
  'vip.setup.pointConfig.minPointRequired': '请输入最小积分',
  'vip.setup.pointConfig.maxPointRequired': '请输入最大积分',
  'vip.setup.pointConfig.probabilityRequired': '请输入概率',
  'vip.setup.pointConfig.minPointInvalid': '最小积分必须为正整数',
  'vip.setup.pointConfig.maxPointInvalid': '最大积分必须为正整数',
  'vip.setup.pointConfig.maxLessThanMin': '最大积分不能小于最小积分',
  'vip.setup.pointConfig.probabilityInvalid': '概率必须为0-100之间的数字',
  'vip.setup.pointConfig.totalProbabilityError': '概率总和必须等于100%，当前为{total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': '概率总和必须等于100%',
  'vip.setup.pointConfig.setting': '设置',
  'vip.setup.pointConfig.totalProbability': '总概率',
  'vip.setup.pointConfig.action': '操作',

  
  // VIP统一奖励配置
  'vip.unified.scene.upgrade': '升级奖励',
  'vip.unified.scene.retention': '保级奖励',
  'vip.unified.scene.weekly': '周俸禄',
  'vip.unified.scene.monthly': '月俸禄',
  'vip.unified.scene.birthday': '生日奖励',
  'vip.unified.scene.appDaily': 'APP 每日',
  'vip.unified.scene.h5Daily': 'H5 每日',
  'vip.unified.basicReward': '基础奖励',
  'vip.unified.claimConditions': '领取条件',
  'vip.unified.rewardCurrency': '礼金币种',
  'vip.unified.reward': '礼金',
  'vip.unified.point': '积分',
  'vip.unified.ticket': '参与券',
  'vip.unified.flowMultiple': '流水倍数',
  'vip.unified.requiresDeposit': '发放需存款',
  'vip.unified.requiresBetflow': '发放需流水',
  'vip.unified.verifyMobile': '手机认证',
  'vip.unified.pointConfig': '积分配置',
  'vip.unified.claimValidityDays': '可领有效期（天）',
  'vip.unified.enterReward': '请输入礼金',
  'vip.unified.enterPoint': '请输入积分',
  'vip.unified.enterFlowMultiple': '请输入流水倍数',
  'vip.unified.enterRequiresDeposit': '请输入存款要求',
  'vip.unified.enterRequiresBetflow': '请输入流水要求',
  'vip.unified.enterClaimValidityDays': '请输入有效期',
  'vip.unified.selectTicket': '请选择参与券',
  'vip.unified.enterQuantity': '请输入数量',
  'vip.unified.quantity': '数量',

  // VIP手动调整
  'vip.adjust.title': '手动调整 VIP',
  'vip.adjust.singleTab': '单个调整',
  'vip.adjust.batchTab': '批量调整',
  'vip.adjust.memberAccount': '会员账号',
  'vip.adjust.enterMemberAccount': '输入会员账号后回车查询',
  'vip.adjust.enterMemberAccountRequired': '请输入会员账号',
  'vip.adjust.query': '查询',
  'vip.adjust.account': '账号',
  'vip.adjust.currentVip': '当前VIP',
  'vip.adjust.growthValue': '成长值',
  'vip.adjust.toNextLevel': '距下一级',
  'vip.adjust.maxLevel': '已满级',
  'vip.adjust.adjustType': '调整类型',
  'vip.adjust.adjustGrow': '调整成长值',
  'vip.adjust.adjustGrowDesc': '增加或扣减经验值',
  'vip.adjust.adjustLevel': '调整VIP等级',
  'vip.adjust.adjustLevelDesc': '直接变更VIP等级',
  'vip.adjust.direction': '调整方向',
  'vip.adjust.increase': '增加(+)',
  'vip.adjust.decrease': '扣减(-)',
  'vip.adjust.adjustValueLabel': '调整数值',
  'vip.adjust.positiveInteger': '正整数',
  'vip.adjust.enterAdjustValue': '请输入调整的成长值',
  'vip.adjust.exceedCurrentGrow': '扣减不能超过当前成长值（{{value}}）',
  'vip.adjust.targetLevel': '目标VIP等级',
  'vip.adjust.selectTargetLevel': '请选择目标等级',
  'vip.adjust.currentLevelTag': '当前等级',
  'vip.adjust.targetLevelSame': '目标等级与当前等级相同',
  'vip.adjust.levelThresholdInfo': 'VIP{{level}} 起始成长值：{{threshold}}，成长值将设为 {{threshold}}',
  'vip.adjust.remark': '备注',
  'vip.adjust.remarkOptional': '选填，200字',
  'vip.adjust.remarkPlaceholder': '如：活动补发、系统异常补偿、风控扣减等',
  'vip.adjust.changePreview': '变更预览',
  'vip.adjust.upgradeLabel': '（升级）',
  'vip.adjust.downgradeLabel': '（降级）',
  'vip.adjust.upgradeImpact': '升级影响范围（以下变更将立即或按周期生效）',
  'vip.adjust.downgradeImpact': '降级影响范围（以下变更将立即或按周期生效）',
  'vip.adjust.confirmTitle': '确认执行调整？',
  'vip.adjust.confirmOk': '确认执行',
  'vip.adjust.cancel': '取消',
  'vip.adjust.confirmExec': '即将对会员 {{account}} 执行：',
  'vip.adjust.confirmWarning': '此操作立即生效，记录不可删除。',
  'vip.adjust.submitSuccess': '调整成功，已更新 {{account}} 的VIP数据',
  'vip.adjust.submitFailed': '调整失败，请重试',
  'vip.adjust.requestFailed': '请求失败，请重试',
  'vip.adjust.memberNotFound': '未找到该会员，请确认账号',
  'vip.adjust.queryFailed': '查询失败，请重试',
  'vip.adjust.lookupFirst': '请先查询会员账号',
  'vip.adjust.enterValue': '请输入调整数值',
  'vip.adjust.confirmBtn': '确认调整',
  'vip.adjust.close': '关闭',
  'vip.adjust.manualAdjust': '手动调整',
  'vip.adjust.system': '系统',
  'vip.adjust.impact.upgradeReward': '升级礼金：触发 VIP{{level}} 发放（已领取不重发）',
  'vip.adjust.impact.withdrawLimit': 'VIP提款额度：立即变更为 VIP{{level}} 限额',
  'vip.adjust.impact.retentionProtection': '保级周期：从今日起重新计算',
  'vip.adjust.impact.pointMall': '积分商城/大转盘：解锁 VIP{{level}} 资格',
  'vip.adjust.impact.customerService': '客服分流：下次开聊按 VIP{{level}} 分流',
  'vip.adjust.impact.notification': '站内信：推送升级通知',
  'vip.adjust.impact.noRecovery': '已发放的礼金/积分不追回，后续按 VIP{{level}} 标准发放',
  'vip.adjust.impact.withdrawLimitDown': 'VIP提款额度：立即降低为 VIP{{level}} 限额',
  'vip.adjust.impact.loseQualification': '积分商城/大转盘：失去超出 VIP{{level}} 的兑换资格',
  'vip.adjust.impact.noNotification': '站内信：不推送通知',
  'vip.adjust.uploadFile': '请先上传文件',
  'vip.adjust.batchTaskCreated': '批量任务已创建，任务ID: {{taskId}}',
  'vip.adjust.uploadFailed': '上传处理失败',
  'vip.adjust.uploadError': '上传失败，请重试',
  'vip.adjust.templateDownloading': '模板下载中...',
  'vip.adjust.templateDownloadFailed': '模板下载失败',
  'vip.adjust.downloadTemplate': '下载导入模板',
  'vip.adjust.templateGuide': '模板填写说明',
  'vip.adjust.colName': '列名',
  'vip.adjust.colRequired': '必填',
  'vip.adjust.colDesc': '说明',
  'vip.adjust.colExample': '示例',
  'vip.adjust.colMemberAccountDesc': '与后台会员列表一致',
  'vip.adjust.colAdjustTypeDesc': '1=调整成长值，2=调整VIP等级',
  'vip.adjust.colAdjustTypeExample': '1',
  'vip.adjust.colDirectionRequired': '调整成长值时必填',
  'vip.adjust.colDirectionDesc': '1=增加，2=扣减；调整等级时留空',
  'vip.adjust.colDirectionExample': '1',
  'vip.adjust.colValueDesc': '成长值=正整数；等级=目标等级号(0~30)',
  'vip.adjust.colRemarkRequired': '否',
  'vip.adjust.colRemarkDesc': '≤200字，为空时用批次备注',
  'vip.adjust.colRemarkExample': '活动补发',
  'vip.adjust.uploadDragText': '点击或拖拽上传 CSV 文件',
  'vip.adjust.uploadHint': '单次 ≤ 5000 条，文件 ≤ 20MB',
  'vip.adjust.fileSizeLimit': '文件大小不能超过 20MB',
  'vip.adjust.batchRemark': '批次备注',
  'vip.adjust.batchRemarkOptional': '选填，本批次共用',
  'vip.adjust.batchRemarkPlaceholder': '如：3月活动补发成长值',
  'vip.adjust.batchCreatedTitle': '批量调整任务已创建',
  'vip.adjust.batchCheckProgress': '任务将异步执行，请在"批量任务"Tab中查看进度',
  'vip.adjust.confirmBatch': '确认执行批量调整',
  'vip.adjust.yes': '是',

  // VIP批量任务
  'vip.batch.title': '批量任务',
  'vip.batch.taskId': '任务ID',
  'vip.batch.fileName': '文件名',
  'vip.batch.totalCount': '总条数',
  'vip.batch.success': '成功',
  'vip.batch.fail': '失败',
  'vip.batch.status': '状态',
  'vip.batch.batchRemark': '批次备注',
  'vip.batch.operator': '操作人',
  'vip.batch.createTime': '创建时间',
  'vip.batch.completeTime': '完成时间',
  'vip.batch.action': '操作',
  'vip.batch.pending': '待处理',
  'vip.batch.processing': '处理中',
  'vip.batch.completed': '已完成',
  'vip.batch.failed': '失败',
  'vip.batch.unknown': '未知',
  'vip.batch.refresh': '刷新',
  'vip.batch.failDetail': '失败明细',
  'vip.batch.refreshList': '刷新列表',
  'vip.batch.fetchFailed': '获取任务列表失败',
  'vip.batch.statusRefreshed': '状态已刷新',
  'vip.batch.refreshFailed': '刷新失败',
  'vip.batch.noFailDetail': '没有失败明细可导出',
  'vip.batch.exportSuccess': '导出成功',
  'vip.batch.exportFailed': '导出失败',

  // 玩家专属每日提款限额（FBMPLAY-1704）
  'vip.memberLimit.buttonTitle': '提现限额',
  'vip.memberLimit.modalTitle': '设置每日提现限额',
  'vip.memberLimit.currency': '币种',
  'vip.memberLimit.mode': '每日提现限额 · 执行方式',
  'vip.memberLimit.modeVip': '按 VIP 等级每日提现限额执行（默认）',
  'vip.memberLimit.modeMember': '按玩家专属每日提现限额执行',
  'vip.memberLimit.amount': '专属每日提现限额（/ 日）',
  'vip.memberLimit.amountHint': '支持高于或低于 VIP 默认；输入 -1 表示不限额；不允许输入 0',
  'vip.memberLimit.diff': '较 VIP{level} 默认 {sign}{diff}',
  'vip.memberLimit.diffSame': '与 VIP{level} 默认相同',
  'vip.memberLimit.diffVipUnlimited': 'VIP{level} 默认为不限额',
  'vip.memberLimit.amountInvalid': '请输入 -1 或大于 0 的金额',
  'vip.memberLimit.enterAmount': '请输入专属每日提现限额',
  'vip.memberLimit.unlimited': '不限额',
  'vip.memberLimit.unlimitedCell': '不限额（-1）',
  'vip.memberLimit.perDay': '日',
  'vip.memberLimit.remark': '备注',
  'vip.memberLimit.enterRemark': '请说明本次调整原因',
  'vip.memberLimit.effectHint': '保存后立即生效；今日已提不受影响，今日剩余可提额度按新限额重算',
  'vip.memberLimit.saveSuccess': '保存成功',
  'vip.memberLimit.saveFailed': '保存失败',
  'vip.memberLimit.memberAccount': '会员账号',
  'vip.memberLimit.enterMemberAccount': '请输入会员账号',
  'vip.memberLimit.statusActive': '生效中',
  'vip.memberLimit.statusDisabled': '已停用',
  'vip.memberLimit.operator': '操作人',
  'vip.memberLimit.enterOperator': '请输入操作人',
  'vip.memberLimit.operateTime': '操作时间',
  'vip.memberLimit.edit': '编辑',
};
